import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { fieldAssetsOptions } from 'App/data-export/store/selectors/fieldAssetsOptions'
import { useMemo } from 'react'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'

export const useFieldAssetsOptions = (formState: TDataExportStoreState['formState']) => {
  return useMemo(() => {
    return fieldAssetsOptions({
      propertyId: formState.propertyId,
      fieldAssetStoreState: fieldAssetStore.getState(),
    })
  }, [formState.propertyId])
}
